import React from "react";
import DocumentCard from "components/card/DocumentCard";
import { FileCheck, TrendingUp, FileText } from "lucide-react";

import { documents as contractDocs } from "./Contracts";
import { documents as promotionDocs } from "./Promotions";
import { documents as compensationDocs } from "./Compensation";

const icons = {
  Contracts: <FileCheck className="w-4 h-4 text-blue-600" />,
  Promotions: <TrendingUp className="w-4 h-4 text-purple-600" />,
  Compensation: <FileText className="w-4 h-4 text-emerald-600" />,
};

const AllDocuments = () => {
    const groupedDocuments = [
        { category: "Contracts", docs: contractDocs },
        { category: "Promotions", docs: promotionDocs },
        { category: "Compensation", docs: compensationDocs },
    ];

    return (
        <div className="flex flex-col">
            {groupedDocuments.map((group, i) => (
                <div key={i} >
                    <div className="space-y-3">
                        <h3 className="text-[16px] font-semibold flex items-center gap-2">
                            {icons[group.category]} {group.category} ({group.docs.length})
                        </h3>

                        <div className="flex flex-col gap-3">
                            {group.docs.map((doc, index) => (
                                <DocumentCard
                                    key={index}
                                    {...doc}
                                    documentData={doc}
                                    onDownload={() => console.log(`Download ${doc.title}`)}
                                />
                            ))}
                        </div>
                    </div>
                    {i !== groupedDocuments.length - 1 && 
                        <div className="bg-gray-200 h-px w-full my-6"></div>
                    }
                </div>
            ))}
        </div>
    );
};

export default AllDocuments;
